import { StateCreator } from 'zustand';

export interface SelectedPlotSlice {
  plotId?: number;
  setPlotId: (plotId?: number) => void;
  clearPlotId: () => void;
  hasEmptyFields: boolean;
  setHasEmptyFields: (hasEmptyFields: boolean) => void
}

export const CreateSelectedPlotSlice: StateCreator<SelectedPlotSlice> = (
  set
) => ({
  plotId: undefined,
  hasEmptyFields: false,
  setPlotId: (plotId?: number) => set({ plotId }),
  clearPlotId: () => set({plotId: undefined}),
  setHasEmptyFields: (hasEmptyFields) => set({hasEmptyFields})
});
